export default __webpack_public_path__ + "static/media/WW15MGH.d068998a.DAC";